import React from "react"
import PropTypes from "prop-types"
import { Button } from "@mui/material"

/** Shared empty / error placeholder for every lecture screen. */
export default function EmptyState({
    icon,
    title,
    description,
    actionLabel,
    onAction
}) {
    return (
        <div className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-slate-300 bg-white/60 px-6 py-12 text-center sm:py-16">
            {icon && (
                <div className="mb-4 text-slate-400 [&>svg]:h-12 [&>svg]:w-12">
                    {icon}
                </div>
            )}
            <h3 className="text-base font-semibold text-slate-800 sm:text-lg">
                {title}
            </h3>
            {description && (
                <p className="mt-2 max-w-md text-sm text-slate-500">
                    {description}
                </p>
            )}
            {actionLabel && onAction && (
                <Button
                    sx={{ mt: 3 }}
                    variant="contained"
                    size="small"
                    onClick={onAction}
                >
                    {actionLabel}
                </Button>
            )}
        </div>
    )
}

EmptyState.propTypes = {
    icon: PropTypes.node,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    actionLabel: PropTypes.string,
    onAction: PropTypes.func
}
